// @flow

const routes = {
  '/app/settings/email': {
    fetch: () =>
      import(
        /* webpackChunkName: 'account-route' */ 'app/account/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
